import { t } from "@/i18n-js/instance";
import { useIsCustomFontsEnabled } from "@/react/components/shared/BuilderUI/Hooks/useIsCustomFontsEnabled";
import { Form } from "@circle-react-shared/uikit/Form";
import { useCustomColors } from "../../../../hooks/useCustomColors";
import { FontPicker } from "./FontPicker";
import { TypographySliderControl } from "./TypographySliderControl";
import { FONT_FAMILY_OPTIONS, FONT_WEIGHT_OPTIONS } from "./constants";
import type { Typography } from "./constants";

interface FormTextStylesProps {
  typographyToken: Typography;
}

export const FormTextStyles = ({ typographyToken }: FormTextStylesProps) => {
  const {
    customColors,
    handleAddCustomColor,
    themeColors,
    flattenedCssVariables,
  } = useCustomColors();
  const isCustomFontsEnabled = useIsCustomFontsEnabled();

  const generateFormItemName = (name: string) =>
    `theme.${typographyToken}.theme-website-${typographyToken}-${name}`;

  return (
    <div className="flex-1 px-6 py-5">
      {isCustomFontsEnabled ? (
        <FontPicker typographyToken={typographyToken} />
      ) : (
        <>
          <Form.Item
            isFirstChild
            hideBorder
            hideDescription
            name={generateFormItemName("font-family")}
            label={t(
              "builder_ui.css_variables.typography.variables.font_family",
            )}
          >
            <Form.TextSelect
              name={generateFormItemName("font-family")}
              options={FONT_FAMILY_OPTIONS}
            />
          </Form.Item>
          <Form.Item
            hideBorder
            hideDescription
            name={generateFormItemName("font-weight")}
            label={t(
              "builder_ui.css_variables.typography.variables.font_weight",
            )}
          >
            <Form.TextSelect
              name={generateFormItemName("font-weight")}
              options={FONT_WEIGHT_OPTIONS}
            />
          </Form.Item>
        </>
      )}
      <Form.Item
        hideBorder
        hideDescription
        name={generateFormItemName("color-text")}
        label={t("builder_ui.css_variables.typography.variables.color")}
        className="!flex !w-full !items-center !justify-between"
      >
        <Form.ColorPickerV2
          name={generateFormItemName("color-text")}
          cssVariables={flattenedCssVariables}
          shouldResolveCssVariable
          shouldRenderThemeColors
          themeColors={themeColors}
          customColors={customColors}
          onAddCustomColor={handleAddCustomColor}
        />
      </Form.Item>
      <TypographySliderControl
        name={generateFormItemName("font-size")}
        label={t("builder_ui.css_variables.typography.variables.font_size")}
      />
      <TypographySliderControl
        name={generateFormItemName("line-height")}
        label={t("builder_ui.css_variables.typography.variables.line_height")}
      />
      <TypographySliderControl
        name={generateFormItemName("letter-spacing")}
        label={t(
          "builder_ui.css_variables.typography.variables.letter_spacing",
        )}
      />
    </div>
  );
};
